module.exports = __webpack_public_path__ + "assets/medical-pin.47f5c1e7.svg";